import { id } from '@volkswagen-onehub/gfa-financial-data-service';
export const gfaFinancialDataServiceDefinition = {
    id,
    dependencies: {
        featureServices: {
            'financial-data': '^1.0.0'
        }
    },
    create: ({ featureServices }) => {
        const featureService = featureServices['financial-data'];
        return {
            '1.0.0': () => ({ featureService })
        };
    }
};
